import React from 'react';
import PropTypes from 'prop-types';
import { GhostButton } from '@hobs/components/Buttons';
import Switch from '@hobs/components/Switch';
import RadioButton from '@hobs/components/RadioButton';
import Confirm from '@hobs/components/Confirm';
import { CellDate, CellDateTime } from '@hobs/components/Grid/CellDate';
import Icon from '@hobs/components/Icon';
import { USER_ROLES } from '@hobs/utils/constants';

import './Users.scss';

const KEY_ENTER = 13;

class Users extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataState: {
        take: 5,
        skip: 0,
        sort: [{ field: 'FirstName', dir: 'asc' }]
      }
    };
  }

  getCustomFilter(type, field) {
    const { t, userGrid } = this.props;
    const filters = userGrid[type];

    if (!filters) {
      return [];
    }

    return [
      {
        name: t('Select all'),
        default: true,
        value: ''
      },
      ...filters.map(item => ({
        value: `<guid>${item.id}</guid>`,
        name: item.title,
        default: false,
        field: field
      }))
    ];
  }

  _getDefaultColumns() {
    const { t } = this.props;

    return {
      FirstName: {
        title: t('First name'),
        columnMenu: true,
        default: true,
        visible: true
      },
      LastName: {
        title: t('Last name'),
        columnMenu: true,
        default: true,
        visible: true
      },
      Email: {
        title: t('Email'),
        columnMenu: true,
        default: true,
        visible: true
      },
      UnitName: {
        title: t('Assigned to'),
        columnMenu: true,
        default: true,
        visible: true
      },
      RoleName: {
        title: t('Role'),
        columnMenu: true,
        default: true,
        visible: true,
        customFilter: {
          data: this.getCustomFilter('roles', 'RoleId')
        }
      },
      LoginExpiration: {
        title: t('Login expiration'),
        columnMenu: true,
        default: true,
        visible: true,
        filter: 'date',
        cell: CellDate
      },
      LastLogin: {
        title: t('Last login'),
        columnMenu: true,
        default: true,
        visible: true,
        filter: 'date',
        cell: CellDateTime
      },
      IsActive: {
        title: t('Is Active'),
        default: false,
        visible: true,
        cell: ({ dataItem }) => {
          return (
            <td>
              <div className="users-view--bool-column">
                <RadioButton
                  disabled={dataItem.IsUserActiveInParty}
                  checked={dataItem.IsUserActiveInParty}
                  onChange={() => this.onIsActiveChange(dataItem)}
                />
              </div>
            </td>
          );
        }
      },
      Locked: {
        title: t('Acc. Locked'),
        default: true,
        visible: true,
        cell: ({ dataItem }) => {
          return (
            <td>
              <div className="users-view--bool-column">
                <Switch disabled={true} checked={dataItem.Locked} />
                {dataItem.Locked ? t('Locked') : t('Unlocked')}
              </div>
            </td>
          );
        }
      },
      controls: {
        title: '',
        headerCell: () => <></>,
        cell: this.controls,
        default: true,
        visible: true,
        width: 100
      }
    };
  }

  getDefaultColumns() {
    return this._getDefaultColumns();
  }

  componentDidMount() {
    this.props.getUserGrid(this.props.partyId);
    this.loadODataQuery();
  }

  componentWillUnmount() {
    this.props.resetOData();
  }

  dataStateChange = e => {
    this.setState(
      {
        dataState: e.dataState
      },
      () => {
        this.loadODataQuery();
      }
    );
  };

  loadODataQuery = () => {
    this.props.queryOData(
      `UsersQuery(${this.props.partyId})`,
      this.state.dataState
    );
  };

  getUserPathName(userId) {
    if (userId) {
      return `${this.props.location.pathname.replace(
        '/user',
        ''
      )}/user/${userId}`;
    }

    return `${this.props.location.pathname.replace('/user', '')}/user`;
  }

  controls = props => {
    const { hasUserPermission } = this.props;
    if (
      !hasUserPermission(USER_ROLES.SystemAdmin) &&
      props.dataItem.IsSystemAdmin
    ) {
      return null;
    }
    if (
      props.dataItem.IsUserActiveInParty === undefined ||
      props.dataItem.IsUserActiveInParty
    ) {
      return (
        <td className="users-view--controls">
          <GhostButton
            iconLeft={<Icon icon="pen" />}
            to={this.getUserPathName(props.dataItem.UserId)}
          >
            {this.props.t('Edit')}
          </GhostButton>
        </td>
      );
    }

    return null;
  };

  handleQuickSearchChange = event => {
    if (event.keyCode === KEY_ENTER) {
      this.setState(
        {
          dataState: {
            ...this.state.dataState,
            quickSearch: event.target.value
          }
        },
        () => {
          this.loadODataQuery();
        }
      );
    }
  };
}

Users.propTypes = {
  queryOData: PropTypes.func,
  resetOData: PropTypes.func,
  getUserGrid: PropTypes.func,
  onIsActiveChange: PropTypes.func,
  location: PropTypes.object,
  userGrid: PropTypes.object,
  t: PropTypes.func,
  partyId: PropTypes.string,
  hasUserPermission: PropTypes.func
};

export default Users;
